import _ from "lodash";
import WidgetContainerComponent from "../components/widget/widget-container.component";
import AttendanceWorkTypePieChartComponent from "../components/charts/pie/attendance-work-type-pie-chart.component";
import AttendanceScheduledVisitsDonutChartComponent from "../components/charts/pie/attendance-scheduled-visits-donut-chart.component";
import SmallTextWidgetComponent from "../components/widget/small-text-widget.component";
import ViewBase from "../views/view-base.view";
import HomeDashboardModel from "../models/home/home-dashboard.model";

export default function AttendanceWidget() {

  ViewBase.call(this);

  let chartData1, chartData2, lateData, earlyLeaveData;

  let getChartData = function () {

    HomeDashboardModel.getAttendanceWorkTypeData(
      (result) => {
        // console.log('getAttendanceWorkTypeData - result', JSON.parse(JSON.stringify(result)));
        chartData1 = result;
      }, (error) => {
        console.error('getAttendanceWorkTypeData - error', error);
      }
    );

    HomeDashboardModel.getAttendanceCheckInOutData(
      (result) => {
        // console.log('getAttendanceCheckInOutData - result', JSON.parse(JSON.stringify(result)));
        chartData2 = result;
      }, (error) => {
        console.error('getAttendanceCheckInOutData - error', error);
      }
    );

    HomeDashboardModel.getAttendanceAbnormalData(
      (result) => {
        // console.log('getAttendanceAbnormalData - result', JSON.parse(JSON.stringify(result)));
        lateData = result.find(o => o.attendanceAbnormalTypeCode === "001");
        earlyLeaveData = result.find(o => o.attendanceAbnormalTypeCode === "002");
        // console.log('getAttendanceAbnormalData - lateData', JSON.parse(JSON.stringify(lateData)));
        // console.log('getAttendanceAbnormalData - earlyLeaveData', JSON.parse(JSON.stringify(earlyLeaveData)));
      }, (error) => {
        console.error('getAttendanceAbnormalData - error', error);
      }
    );
  }

  return {
    oninit: function (vnode) {
      getChartData();
    },
    view: (vnode) => {
      return [
        m(WidgetContainerComponent, {
          title: this.getText('LT00000111', 'Attendance'),
          links: [
            { 
              text: this.getText('LT00000108', 'Details'),
              url: '/attendance'
            }
          ],
        }, [
          m('.d-flex.align-items-stretch.flex-wrap',
            { 
              style: {
                gap: '16px',
              } 
            },
            m('.flex-grow-1',
              m('.card.widget-component', m('.card-body',
                chartData1 &&
                m(AttendanceWorkTypePieChartComponent, { data: chartData1 })
              )),
            ),
            m('.flex-grow-1',
              m('.card.widget-component', m('.card-body',
                chartData2 &&
                m(AttendanceScheduledVisitsDonutChartComponent, { data: chartData2 })
              )),
            ),
            m('.d-flex.flex-lg-column',
              { 
                style: {
                  gap: '16px',
                } 
              },
                lateData &&
                m(SmallTextWidgetComponent,
                  {
                    class: 'home-widget_late-stat',
                    title: lateData.attendanceAbnormalTypeName,
                    mainText: String(lateData.count),
                    secondaryText: lateData.percent + '%',
                    additionalText: 'Avg. ' + lateData.average + ' min',
                  }
                ),
                earlyLeaveData &&
                m(SmallTextWidgetComponent,
                  {
                    class: 'home-widget_early-leave-stat',
                    title: earlyLeaveData.attendanceAbnormalTypeName,
                    mainText: String(earlyLeaveData.count),
                    secondaryText: earlyLeaveData.percent + '%',
                    additionalText: 'Avg. ' + earlyLeaveData.average + ' min',
                  }
                ),
            ),
          ),
        ]),
      ]
    }
  }
}
